<template>
    <div class="logoPage"
         :class="{'fullImg': fullImg }"
         :style="{ backgroundImage: bgUrl }"
    >
        <div class="logo"><img src="../../assets/logo.svg" alt="Нова Пошта"></div>
    </div>
</template>

<script>
    export default {
        name: "custom-header",
        props: {
            fullImg: Boolean,
            imgNumber: [String, Number],
        },
        data() {
            return {
                isMobile: window.innerWidth <= 600
            }
        },
        mounted () {
            window.addEventListener('resize', this.onResize)
        },
        beforeDestroy () {
            window.removeEventListener('resize', this.onResize)
        },

        computed: {
             bgUrl: function () {
                 return this.imgNumber === undefined ? null : 'url("/static/headers/' + this.imgNumber +
                     (this.isMobile ? '_mob' : '') +
                 '.jpg")'
             }
        },
        methods: {
            onResize: function () {
                this.isMobile = window.innerWidth <= 600;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .logoPage {
        position: relative;
        background: rgb(253,248,243);
        background: linear-gradient(0deg, rgba(253,248,243,1) 0%, rgba(240,233,223,1) 100%);
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        .logo {
            position: absolute;
            bottom: 0;
            right: 0;
            padding: 11px 50px 11px 11px;
            background-color: #DA291C;
            img {
                display: block;
                color: #fff;
                font-size: 36px;
                line-height: 28px;
                font-weight: 700;
                font-style: normal;
                text-transform: uppercase;
                white-space: nowrap;
            }
        }
    }
    @media (min-width: 601px) {
        .logoPage {
            height: 100vh;
            margin-top: 0;
            .logo {
                padding: 17px 70px 17px 25px;
                max-width: 80%;
                img {
                    height: 27px;
                }
            }
        }
    }
    @media (min-width: 901px) {
        .logoPage .logo { padding: 25px 140px 20px 32px;}
    }
    @media (max-width: 600px) {
        .logoPage {
            height: 204px;
            margin-top: -164px;
            &.fullImg { margin-top: 0;}
        }
    }

</style>